/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoFigmaIcon24Solid = forwardRef('LogoFigmaIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M6 5a3 3 0 0 1 3-3h3v6H9a3 3 0 0 1-3-3Z" }),
        React.createElement("path", { d: "M6 12a3 3 0 0 1 3-3h3v6H9a3 3 0 0 1-3-3Z" }),
        React.createElement("path", { d: "M19 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" }),
        React.createElement("path", { d: "M9 16a3 3 0 1 0 3 3v-3H9Z" }),
        React.createElement("path", { d: "M16 2h-3v6h3a3 3 0 1 0 0-6Z" })));
});
